import { MuiF } from '../../../../../../../Mui/F/Function/module/MuiF.js';

export const handleTopMenuDoneButtonClick = () => () => MuiF.closeFrame();
